import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import App from '~/components/App'

import '~/plugins'
import '~/components'
import '~/filters'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    store,
    router,
    ...App
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js